import { CONTENT_TYPE } from "@/constants/index.js";

import { contentTypeIcons } from "../../../utils/contentTypeIcons.js";

export default function TypeIcon(props) {
  const { type, className = "" } = props;

  switch (type) {
    case CONTENT_TYPE.THREE_HUNDRED_SIXTY_PHOTO:
    case CONTENT_TYPE.THREE_DIMENSIONAL_MODEL:
    case CONTENT_TYPE.VIRTUAL_TOUR:
    case CONTENT_TYPE.VIDEO:
    case CONTENT_TYPE.PHOTO:
    case CONTENT_TYPE.PDF:
    case CONTENT_TYPE.AUDIO:
    case CONTENT_TYPE.LINK:
      return contentTypeIcons[type]({ className });
    default:
      return (
        <div data-testid="default-type-icon" className={className} style={{ width: "100%" }}>
          {type}
        </div>
      );
  }
}
